const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "User",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "File Name",
    dataIndex: "file",
    render: defaultRender,
  },
  {
    title: 'File No.',
    dataIndex: 'file_number',
    render: defaultRender,
  },
  {
    title: 'Invoice No.',
    dataIndex: 'invoice_number',
    render: defaultRender,
  },
  {
    title: 'Generated By',
    dataIndex: 'generated_name',
    render: defaultRender,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: defaultRender,
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: defaultRender,
  },
  {
    title: "Invoice Send Date",
    dataIndex: "invoice_send_date",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

export default columns;
